import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useFormStep } from "../store/FormStepStore";
import { useUserStore } from "../store/UserStore";
import { useRepStore } from "../store/RepresentativeStore";
import { mask_number } from "../utils/mask_number";
import { useForm } from "react-hook-form";
import Loader from "./Loader";
import Swal from "sweetalert2";
import sendToken from "./sendToken";
import Header from "./assist/Title";

export default function ConfirmPhoneAndEmail() {
  const { source } = useParams();
  const step = useFormStep((state) => state.step);
  const setStep = useFormStep((state) => state.setStep);
  const userDetail = useUserStore((state) => state.userDetails);
  const repDetails = useRepStore((state) => state.repDetails);
  const setUserInfos = useUserStore((state) => state.setUserDetails);
  const setRepInfo = useRepStore((state) => state.setRepDetails);
  const [isCurrentPhoneNumber, setIsCurrentPhoneNumber] = useState("");
  const [isValidEmailAddress, setIsValidEmailAddress] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const setOtpChannel = useUserStore((state) => state.setOtpChannel);

  const userDetails = source === "rep" ? repDetails : userDetail;
  const setUserInfo = source === "rep" ? setRepInfo : setUserInfos;

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  useEffect(() => {
    // if (userDetails.pulledEmail === undefined) {
    setIsValidEmailAddress("");
    // }

    // if (userDetails.pulledPhone === undefined) {
    setIsCurrentPhoneNumber("");
    // }
  }, []);

  useEffect(() => {
    if (isValidEmailAddress === "yes") {
      setUserInfo({ ...userDetails, email: userDetails.pulledEmail });
      console.log(userDetails);
    }
    if (isCurrentPhoneNumber === "yes") {
      setUserInfo({ ...userDetails, phone: userDetails.pulledPhone });
    }
  }, [isCurrentPhoneNumber, isValidEmailAddress]);

  const handleChange = () => {};

  const onConfirmPhoneNumber = (data) => {
    setIsLoading(true);
    if (
      isCurrentPhoneNumber === "" ||
      isCurrentPhoneNumber === undefined ||
      isValidEmailAddress === undefined ||
      isValidEmailAddress === ""
    ) {
      Swal.fire({
        title: "Select options to confirm Email and Phone Number",
        text: " ",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#1C89DE",
      });
      setIsLoading(false);
      return;
    }
    if (userDetails.phone === undefined) {
      Swal.fire({
        title: "Error!",
        text: "User phone must be provided",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#1C89DE",
      });
      setIsLoading(false);
      return;
    }
    if (userDetails.email === undefined) {
      Swal.fire({
        title: "Error!",
        text: "User Email must be provided",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#1C89DE",
      });
      setIsLoading(false);
      return;
    }
    //send token
    setOtpChannel("sms");
    sendToken("sms", userDetails.phone, userDetails.email);
    // sendToken("email", userDetails.email);
    Swal.fire({
      title: "Verification token sent to",
      text: mask_number(userDetails.phone) + " and " + userDetails.email,
      icon: "success",
      confirmButtonText: "Continue",
      confirmButtonColor: "#1C89DE",
    }).then(() => {
      setStep(2);
      setIsLoading(false);
      if (source === "main") {
        window.location = "/token/main";
      } else {
        window.location = "/token/rep";
      }
    });
  };

  if (step < 1) {
    window.location = "/signup";
  }

  return (
    <div>
      <Header />
      <div className="flex justify-center items-center pt-8 text-center px-4 bg-gray-100">
        <div>
          <p className="mt-5 text-gray-800 text-2xl mb-4 font-bold">
            Confirm Email and Phone Number
          </p>
          <div
            className={`${isCurrentPhoneNumber === "no" ? "hidden" : "block"}`}
          >
            <label htmlFor="token" className="block text-gray-900 mt-3 text-lg">
              Is this your current phone number{" "}
              <span className="text-red-600">
                {mask_number(userDetails.pulledPhone)} ?
              </span>
              <div
                onChange={(e) => {
                  setIsCurrentPhoneNumber(e.target.value);
                }}
                className="ml-5 text-center"
              >
                <label>
                  <input
                    type="radio"
                    className="mr-2"
                    name="current_number"
                    value="yes"
                    required
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    className="ml-8 mr-2 mb-4"
                    name="current_number"
                    value="no"
                    required
                  />
                  No
                </label>
              </div>
            </label>
          </div>
          {isCurrentPhoneNumber === "no" && (
            <>
              <label
                htmlFor="token"
                className=" text-left block text-gray-900 mt-3 text-lg"
              >
                Current Phone Number{" "}
              </label>
              <div className="flex">
                <div className="flex-1">
                  <input
                    name="r_phone"
                    type="text"
                    {...register("r_phone", { required: true })}
                    onChange={(e) => {
                      setUserInfo({ ...userDetails, phone: e.target.value });
                    }}
                    className="w-full bg-white border-2 border-gray-300 rounded-lg h-10 mb-1 text-lg mt-1 text-gray-800 leading-loose hover:border-green-800 py-1 px-2"
                  />
                </div>
                <div
                  className="pt-1 hover:bg-black px-1 my-2 ml-1 cursor-pointer bg-blue-500 rounded text-gray-100"
                  onClick={() => {
                    setIsCurrentPhoneNumber("");
                  }}
                >
                  Back
                </div>
              </div>
            </>
          )}

          {isValidEmailAddress === "no"}
          <div
            className={`${isValidEmailAddress === "no" ? "hidden" : "block"}`}
          >
            <label
              htmlFor="token"
              className="block text-gray-900 mt-3 text-center text-lg"
            >
              Is this your valid email address{" "}
              <span className="text-red-600 lowercase">
                {userDetails.pulledEmail}
              </span>
              <div
                onChange={(e) => {
                  setIsValidEmailAddress(e.target.value);
                }}
                className="ml-5 text-center"
              >
                <label>
                  <input
                    type="radio"
                    className="mr-2"
                    name="valid_email"
                    value="yes"
                    required={true}
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    className="ml-8 mr-2 mb-4"
                    name="valid_email"
                    value="no"
                    required={true}
                  />
                  No
                </label>
              </div>
            </label>
          </div>

          {isValidEmailAddress === "no" && (
            <>
              <label
                htmlFor="token"
                className="block text-gray-900 mt-3 text-left text-lg"
              >
                Valid Email Address<span className="text-red-600">{" *"}</span>
              </label>
              <div className="flex">
                <div className="flex-1">
                  <input
                    name="r_email"
                    type="email"
                    {...register("r_email", { required: true })}
                    aria-invalid={errors.r_email ? "true" : "false"}
                    onChange={(e) =>
                      setUserInfo({
                        ...userDetails,
                        email: e.target.value,
                      })
                    }
                    className="w-full bg-white border-2 border-gray-300 rounded-lg h-10 mb-1 text-lg mt-1 text-gray-800 leading-loose hover:border-green-800 py-1 px-2"
                  />
                </div>
                <div
                  className="pt-1 hover:bg-black px-1 my-2 text-left ml-1 cursor-pointer bg-blue-500 rounded text-gray-100"
                  onClick={() => setIsValidEmailAddress("")}
                >
                  Back
                </div>
              </div>

              {errors.r_email?.type === "required" && (
                <p role="alert" className="text-sm text-red-500">
                  Email is required
                </p>
              )}
            </>
          )}
          <button
            className="bg-blue-500 text-lg mt-4 w-full py-2 rounded-lg text-gray-100"
            onClick={handleSubmit(onConfirmPhoneNumber)}
          >
            {!isLoading && "Confirm"}
            {isLoading && <Loader />}
          </button>
        </div>
      </div>
    </div>
  );
}
